import React from 'react';
import _ from 'lodash';
import { Row, Col } from 'react-bootstrap';
import BannerImageEditor from "src/legacy/components/BannerImageEditor/";
import { ToolBar, ToolBarGroup } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';
import DefaultCollectionDetailTemplate from "src/templates/DefaultCollectionDetail.handlebars";
import DefaultBackground from 'src/legacy/images/collections/DefaultBackground.jpeg';
import MasonryType from 'src/legacy/images/collections/masonry.svg';
import CarouselType from 'src/legacy/images/collections/carousel.svg';
import BentoType from 'src/legacy/images/collections/bento.png';
import { EXPERIENCE_BENTO, EXPERIENCE_CAROUSEL, EXPERIENCE_MASONRY } from 'src/legacy/constants/collectionConstants';
import { localizedStrings } from 'src/localization/index.jsx';
import cx from 'classnames';
import styles from '../../accountManagementView.module.scss';
import userRoleService from 'src/services/userRoles.service';
import Banner from 'src/legacy/components/Banner';
import { DescriptionEditor } from 'src/pages/collection/components/description';
import CollectionWidgetManager from 'src/services/collections.widget.service';

const viewerTypes = [EXPERIENCE_MASONRY, EXPERIENCE_CAROUSEL, EXPERIENCE_BENTO];
class CollectionSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editBanner: false,
      menuState: {
        primaryAction: 'edit'
      }
    }

    this.handleTemplateChange = this.handleTemplateChange.bind(this);
    this.handleEditBannerClicked = this.handleEditBannerClicked.bind(this);
    this.onBackgroundImageChanged = this.onBackgroundImageChanged.bind(this);
    this.handleSharedByClicked = this.handleSharedByClicked.bind(this);
    this.handleLiveCollectionClicked = this.handleLiveCollectionClicked.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedCollectionSettings = this.localizedSettings.account.account_management.tabs.collection_settings;
    this.localizedDefaultExperience = this.localizedCollectionSettings.default_experience;
  }

  handleTemplateChange(value) {
    const settings = this.props.value.collectionSettings;
    var request = {
      ...settings,
      template: value
    };

    this.props.onChange(request);
  }

  getBackgroundImage(settings) {
    if (settings.banner && settings.banner.background) {
      var background = settings.banner.background;
      if (typeof background === 'string') {
        return background;
      } else if (background.full) {
        return background.full;
      }
    }

    return DefaultBackground;
  }

  getBackgroundType(banner) {
    if (banner == null) {
      return 'image';
    }

    if (banner.mediaType) {
      return banner.mediaType;
    }

    if (banner.background) {
      return banner.background.type;
    }

    return "image";
  }

  handleEditBannerClicked() {
    this.setState({
      editBanner: true
    })
  }

  onBackgroundImageChanged(data) {
    const settings = this.props.value.collectionSettings;
    var request = {
      ...settings,
      banner: {
        ...settings.banner,
        ...data
      }
    };

    this.props.onChange(request);

    this.setState({
      editBanner: false
    });
  }

  handleSharedByClicked() {
    const settings = this.props.value.collectionSettings;
    const sharedByEnabled = _.get(settings, 'banner.sharedByEnabled', true);
    var request = {
      ...settings,
      banner: {
        ...settings.banner,
        sharedByEnabled: !sharedByEnabled
      }
    };

    this.props.onChange(request);
  }

  handleLiveCollectionClicked() {
    const settings = this.props.value.collectionSettings;
    const live = _.get(settings, 'live', false);
    var request = {
      ...settings,
      live: !live
    };

    this.props.onChange(request);
  }


  renderCheckbox(key) {
    const settings = this.props.value.collectionSettings;

    const viewerType = _.get(settings, 'viewerType') || EXPERIENCE_MASONRY;
    var selected = viewerType;
    return (
      <i className={
        cx(styles.checkbox, {
          'paperflite-tick-selected': selected === key,
          'paperflite-radio-button-unselected': selected !== key
        })
      } aria-hidden="true"></i>
    );
  }

  renderMasonryExperienceContent() {
    return (
      <div className={styles.experienceContent}>
        <div onClick={() => this.handleCheckboxChange(EXPERIENCE_MASONRY)} className={styles.selection}>
          {this.renderCheckbox(EXPERIENCE_MASONRY)}
          <span className={styles.title}>{this.localizedDefaultExperience.metro.title}</span>
        </div>
        <div className={styles.descriptionContent}>
          {this.localizedDefaultExperience.metro.description}
        </div>
        <img className={styles.wireframe} src={MasonryType} />
      </div>

    )
  }

  renderCarouselExperienceContent() {
    return (
      <div className={styles.experienceContent}>
        <div onClick={() => this.handleCheckboxChange(EXPERIENCE_CAROUSEL)} className={styles.selection}>
          {this.renderCheckbox(EXPERIENCE_CAROUSEL)}
          <span className={styles.title}>{this.localizedDefaultExperience.carousel.title}</span>
        </div>
        <div className={styles.descriptionContent}>
        {this.localizedDefaultExperience.carousel.description}
        </div>
        <img className={styles.wireframe} src={CarouselType} />
      </div>
    )
  }

  renderBentoExperienceContent() {
    return (
      <div className={styles.experienceContent}>
        <div onClick={() => this.handleCheckboxChange(EXPERIENCE_BENTO)} className={styles.selection}>
          {this.renderCheckbox(EXPERIENCE_BENTO)}
          <span className={styles.title}>{this.localizedDefaultExperience.bento.title}</span>
        </div>
        <div className={styles.descriptionContent}>
        {this.localizedDefaultExperience.bento.description}
        </div>
        <img className={styles.wireframeBento} src={BentoType} />
      </div>
    )
  }

  renderViewerType(experienceType) {
    switch (experienceType) {
      case EXPERIENCE_MASONRY:
        return this.renderMasonryExperienceContent()
      case EXPERIENCE_CAROUSEL:
        return this.renderCarouselExperienceContent()
      case EXPERIENCE_BENTO:
        return this.renderBentoExperienceContent()
      default:
        break;
    }
  }

  handleCheckboxChange(key) {
    const settings = this.props.value.collectionSettings;
    const selected = _.get(settings, 'viewerType') || EXPERIENCE_MASONRY;

    if (selected === key) {
      return;
    }
    
    var request = {
      ...settings,
      viewerType: key
    };

    this.props.onChange(request);
  }

  render() {
    const settings = this.props.value.collectionSettings;

    const backgroundImage = this.getBackgroundImage(settings);
    const mediaType = this.getBackgroundType(settings.banner);
    const sharedByEnabled = _.get(settings, 'banner.sharedByEnabled', true);
    const liveEnabled = _.get(settings, 'live', false);
    const template = _.get(settings, 'template', DefaultCollectionDetailTemplate);

    return (
      <div className={styles.collectionSettings}>
        
          <div className={styles.wrapper}>

            <Banner value={settings.banner} default={DefaultBackground} />

            <Row className={styles.editor}>
              <Col md={10}>
                <DescriptionEditor 
                  collection={this.props.value.collectionSettings} //sending collectionSettings instead of collection as the component is expecting template which is part of collectionSettings
                  widgetManager={new CollectionWidgetManager}
                  maxHeight={'none'}
                  menuState={this.state.menuState}
                  onChange={this.handleTemplateChange.bind(this)}
                  onMenuChange={(value) => {
                    this.setState({
                      menuState: value
                    })
                  }}

                />
              </Col>
              <Col md={5} />
            </Row>
          </div>

        
          <ToolBar className={styles.toolbar}>
            <ToolBarGroup>
              <ToolBarButtonItem
                className={cx(styles.action)}
                width="auto"
                height="auto"
                disabled={this.props.updating}
                onClick={this.handleEditBannerClicked}>
                <span className="fa fa-file-image" />{this.localizedCollectionSettings.actions.edit_background}
              </ToolBarButtonItem>
              {userRoleService.canShare() &&
                <ToolBarButtonItem
                  className={cx(styles.action, styles.sharedBy)}
                  width="auto" height="auto"
                  onClick={this.handleSharedByClicked}>
                  <span className={styles.actionButton}>
                    <span className={cx(!sharedByEnabled ? "fa fa-toggle-off" : "fa fa-toggle-on")}></span>{this.localizedCollectionSettings.actions.show_shared_by}
                  </span>
                </ToolBarButtonItem>
              }
              {userRoleService.canShare() &&
                <ToolBarButtonItem
                  className={cx(styles.action, styles.sharedBy)}
                  width="auto" height="auto"
                  onClick={this.handleLiveCollectionClicked}>
                  <span className={styles.actionButton}>
                    <span className={cx(!liveEnabled ? "fa fa-toggle-off" : "fa fa-toggle-on")}></span>{this.localizedCollectionSettings.actions.enable_live_collection}
                  </span>
                </ToolBarButtonItem>
              }
  
            </ToolBarGroup>
          </ToolBar>

        

        <section className={styles.defaultExperienceSection}>
          <div className={styles.heading}>
            <h4>{this.localizedDefaultExperience.title}</h4>
            <span className={styles.description}>
            {this.localizedDefaultExperience.description}
            </span>
          </div>
          <div className={styles.viewerTypesContent}>
            {
              viewerTypes.map(item => {
                return this.renderViewerType(item)

              })
            }
          </div>
        </section>

        <BannerImageEditor
          entity='collection'
          show={this.state.editBanner}
          onChange={this.onBackgroundImageChanged}
          onCancel={() => {
            this.setState({
              editBanner: false
            });
          }}
          user={this.props.user}
          value={{
            ...settings.banner,
            mediaType: mediaType,
            background: backgroundImage
          }}
          source="Settings"
        />
      </div>
    )
  }
}

export default CollectionSettings;